module.exports = __webpack_public_path__ + "img/icone-pastelaria.48fc8349.svg";